import * as React from 'react';
import { Upload, UploadFile, UploadProps } from 'tdesign-react';


type CustomUploadProps= {
  value: UploadFile[];
} & UploadProps;

export const CustomUpload: React.FC<CustomUploadProps> = (props) => {
  const { value } = props;

  const getNormalDom = () => <>
    <Upload
      {...props}
      files={[...value]}
    >
    </Upload>
  </>;

  return (
    <div>
      {getNormalDom()}
    </div>
  );
};

export default CustomUpload;
